import {
  GET_OUTLET_LOCATION_DATA,
  GET_OUTLET_LOCATION_DATA_SUCCESS,
  IGetOutletLocationData,
  IGetOutletLocationDataSuccess,
  ILocationData,
  IManualLocationDataInput,
  IOutlet,
  IRequestOutlets,
  IRequestOutletsError,
  ISetOutlet,
  ISetOutletPickerTab,
  ISetOutletFavourite,
  ISetOutletFavouriteError,
  ISetOutletFavouriteSuccess,
  ISetOutletGoogleLocationData,
  ISetOutletManualLocationData,
  ISetOutlets,
  ISetOutletViewed,
  ISetQuestionnaireSubmitted,
  REQUEST_OUTLETS,
  REQUEST_OUTLETS_ERROR,
  SET_OUTLET,
  SET_OUTLET_PICKER_TAB,
  SET_OUTLET_FAVOURITE,
  SET_OUTLET_FAVOURITE_ERROR,
  SET_OUTLET_FAVOURITE_SUCCESS,
  SET_OUTLET_GOOGLE_LOCATION_DATA,
  SET_OUTLET_MANUAL_LOCATION_DATA,
  SET_OUTLET_VIEWED,
  SET_OUTLETS,
  SET_QUESTIONNAIRE_SUBMITTED
} from "./types";

export const setOutlet = (outlet: IOutlet | null): ISetOutlet => ({
  type: SET_OUTLET,
  payload: outlet
});
export const setOutletPickerTab = (outletPickerTab: number): ISetOutletPickerTab => ({
  type: SET_OUTLET_PICKER_TAB,
  payload: outletPickerTab
});
export const setOutlets = (outlets: IOutlet[]): ISetOutlets => ({
  type: SET_OUTLETS,
  payload: outlets
});
export const requestOutlets = (): IRequestOutlets => ({
  type: REQUEST_OUTLETS
});
export const requestOutletsError = (): IRequestOutletsError => ({
  type: REQUEST_OUTLETS_ERROR
});
export const setOutletViewed = (outletId: string): ISetOutletViewed => ({
  type: SET_OUTLET_VIEWED,
  payload: outletId
});
export const setQuestionnaireSubmitted = (
  outletId: string,
  skip?: boolean
): ISetQuestionnaireSubmitted => ({
  type: SET_QUESTIONNAIRE_SUBMITTED,
  payload: outletId,
  skip
});

export const getOutletLocationData = (outletId: string, force = false): IGetOutletLocationData => ({
  type: GET_OUTLET_LOCATION_DATA,
  payload: {
    outletId,
    force
  }
});
export const getOutletLocationDataSuccess = (
  outletId: string,
  data: ILocationData
): IGetOutletLocationDataSuccess => ({
  type: GET_OUTLET_LOCATION_DATA_SUCCESS,
  payload: {
    outletId,
    data
  }
});
export const setOutletGoogleLocationData = (
  outletId: string,
  outletName: string,
  placeId: string
): ISetOutletGoogleLocationData => ({
  type: SET_OUTLET_GOOGLE_LOCATION_DATA,
  payload: { outletId, outletName, placeId }
});

export const setOutletManualLocationData = (
  outletId: string,
  outletName: string,
  data: IManualLocationDataInput
): ISetOutletManualLocationData => ({
  type: SET_OUTLET_MANUAL_LOCATION_DATA,
  payload: { outletId, outletName, data }
});

export const setOutletFavourite = (outletId: string, favourite: boolean): ISetOutletFavourite => ({
  type: SET_OUTLET_FAVOURITE,
  payload: { outletId, favourite }
});

export const setOutletFavouriteSuccess = (data: {
  outletId: string;
  favourite: boolean;
}): ISetOutletFavouriteSuccess => ({
  type: SET_OUTLET_FAVOURITE_SUCCESS,
  payload: data
});

export const setOutletFavouriteError = (data: {
  outletId: string;
  favourite: boolean;
}): ISetOutletFavouriteError => ({
  type: SET_OUTLET_FAVOURITE_ERROR,
  payload: data
});
